import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { IBranch, IWorkHour } from '../_types';
import { request } from './http-client';
import { TParams } from './types';

export const branchService = {
  getList: (
    params: TParams,
    shipperId?: string,
  ) =>
    request.get<{ branches: IBranch[]; count: string }>(`/v1/branches`, {
      params,
      headers: shipperId ? { Shipper: shipperId } : undefined,
    }),
  findNearest: (
    params: {
      long: number;
      lat: number;
      delivery_zone_id?: string;
      order_type_id?: string;
    },
    shipperId?: string,
  ) =>
    request.get<{ branches: IBranch[] }>('/v1/nearest-branch', {
      params,
      headers: shipperId ? { Shipper: shipperId } : undefined,
    }),
  findNearestByTime: (
    params: {
      long: number;
      lat: number;
      date_time: string;
      order_type_id?: string;
    },
    shipperId?: string,
  ) =>
    request.get<{ branches: IBranch[] }>('/v1/branches/delivery-hours', {
      params,
      headers: shipperId ? { Shipper: shipperId } : undefined,
    }),
  getBranchById: (
    id: string,
    shipperId?: string,
  ): Promise<AxiosResponse<IBranch>> =>
    request.get(`/v1/branches/${id}`, {
      headers: shipperId ? { Shipper: shipperId } : undefined,
    }),
  getWorkingHours: (params: TParams) =>
    request.get<{ working_hours: IWorkHour[] }>(`/v2/working-hours`, {
      params,
    }),

  nightFeedingBranches: async (params: TParams) => {
    const res = await request.get<{ branches: IBranch[]; count: number }>(
      `/v2/after-21-working-branches`,
      { params },
    );

    return res.data;
  },
};

export const useBranchList = ({
  params,
  props = { enabled: false },
  shipperId,
  initialData,
}: {
  params: any;
  props: any;
  shipperId?: string;
  initialData?: {
    count: string;
    branches: IBranch[];
  };
}) => {
  return useQuery<
    {
      count: string;
      branches: IBranch[];
    },
    Error
  >({
    queryKey: ['branch_list', props, params, shipperId],
    queryFn: () =>
      branchService.getList(params, shipperId).then((res) => res?.data),
    initialData,
    ...props,
  });
};
